import { AlertCircle, RefreshCw, Home } from "lucide-react";
import { Button } from "@blueskydataplatform/shared-ui/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@blueskydataplatform/shared-ui/components/ui/card";
import { useNavigate } from "react-router";
import { paths } from "@/config/paths";

const AppRootErrorBoundary = () => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleNavigateHome = () => {
    navigate(paths.home.getHref());
  };

  return (
    <div className="h-screen w-full flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md border-border">
        <CardHeader className="pb-4 space-y-2">
          <div className="w-full flex justify-center mb-2">
            <div className="rounded-full bg-destructive/10 p-3">
              <AlertCircle className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-2xl text-center text-foreground">Something went wrong</CardTitle>
        </CardHeader>
        <CardContent className="text-center text-muted-foreground space-y-4">
          <p>We&apos;re sorry, but it looks like something unexpected happened. This might be a temporary issue.</p>
          <p className="text-sm">If this problem persists, please contact our support team.</p>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button className="w-full sm:w-1/2 gap-2" variant="outline" onClick={handleRefresh}>
            <RefreshCw className="h-4 w-4" />
            Try Again
          </Button>
          <Button className="w-full sm:w-1/2 gap-2" onClick={handleNavigateHome}>
            <Home className="h-4 w-4" />
            Go to Home
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AppRootErrorBoundary;
